import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

import ErrorBoundary from './ErrorBoundary';
import NotFound from './NotFound';

import TrackingPageApp from './TrackingPageApp';
import ReturnsPageApp from './ReturnsPageApp';


const RETURNS_PATH = '/returns';

export default function App({ testData }) {
  if( !window.location.search ) {
    Sentry.captureMessage(`Page visit without URL params. Referrer: '${document.referrer}'`);
    return <NotFound />
  }

  const url = new URL(window.location.href);

  return <ErrorBoundary>
    { url.pathname === RETURNS_PATH ? (
      <ReturnsPageApp />
    ):(
      <TrackingPageApp testData={testData} />
    )}
  </ErrorBoundary>;
}
App.propTypes = {
  testData: PropTypes.object
};
